var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("el-row", { attrs: { type: "flex", justify: "space-between" } }, [
            _c("span", [_vm._v("业绩总览")])
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "top" },
        _vm._l(_vm.numberListTotal, function(item) {
          return _c("div", { staticClass: "top-item" }, [
            _c(
              "div",
              {
                staticClass: "top-item-content",
                style: { backgroundColor: item.color }
              },
              [
                _c("div", { staticClass: "top-item-content-top" }, [
                  _c("i", {
                    class: item.icon,
                    staticStyle: {
                      "font-size": "26px",
                      "font-weight": "bold",
                      color: "white"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "white",
                        "font-size": "16px",
                        "margin-left": "15px"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(item.title))])]
                  )
                ]),
                _c(
                  "div",
                  { staticStyle: { color: "white", "font-size": "60px" } },
                  [_c("span", [_vm._v(_vm._s(item.value))])]
                )
              ]
            )
          ])
        }),
        0
      )
    ]),
    _c(
      "div",
      { staticClass: "down" },
      [_c("chart-visits", { ref: "visits" })],
      1
    ),
    _c("div", { staticClass: "bottom" }, [
      _c(
        "div",
        { staticClass: "bottom-left" },
        [_c("chart-grade", { ref: "grade" })],
        1
      ),
      _c(
        "div",
        { staticClass: "bottom-middle" },
        [_c("chart-new-member", { ref: "member" })],
        1
      )
    ]),
    _c("div", { staticStyle: { height: "50px" } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }